import { render } from "./Toolbox.vue?vue&type=template&id=1e4b2fc9&scoped=true"
import script from "./Toolbox.vue?vue&type=script&lang=js"
export * from "./Toolbox.vue?vue&type=script&lang=js"

import "./Toolbox.vue?vue&type=style&index=0&id=1e4b2fc9&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-1e4b2fc9"

export default script